import { Box, Typography } from "@mui/material";
import { tokens } from "../theme";
import BlurText from "../reactbits/BlurText";
import ElectricBorder from "../reactbits/ElectricBorder";

function Panel({ color, tag, title, children, link }) {
  return (
    <Box
      component="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: "block",
        textDecoration: "none",
        cursor: "pointer",
        height: "100%",
        transition: "transform 0.2s ease",
        "&:hover": {
          transform: "translateY(-4px)",
        },
      }}
    >
      <ElectricBorder color={color} speed={1} chaos={0.12} borderRadius={22}>
        <Box
          sx={{
            bgcolor: tokens.pine2,
            borderRadius: "20px",
            p: { xs: 3.5, md: 4.5 },
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              fontFamily: tokens.mono,
              fontSize: "0.7rem",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color,
              mb: 2,
            }}
          >
            {tag}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontFamily: tokens.display,
              fontWeight: 500,
              fontSize: 20,
              mb: 1,
              color: tokens.paper,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: tokens.paperDim,
              fontSize: 14,
              lineHeight: 1.65,
              flex: 1,
            }}
          >
            {children}
          </Typography>
        </Box>
      </ElectricBorder>
    </Box>
  );
}

export default function Focus() {
  return (
    <Box
      component="section"
      id="focus"
      sx={{ bgcolor: tokens.ink, py: { xs: 8, md: 12.5 }, px: 3 }}
    >
      <Box sx={{ maxWidth: 1080, mx: "auto" }}>
        <Box sx={{ textAlign: "center", maxWidth: 640, mx: "auto", mb: 7 }}>
          <Typography
            sx={{
              fontFamily: tokens.mono,
              fontSize: "0.72rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: tokens.frost,
              mb: 2.25,
            }}
          >
            Two watch systems, one platform
          </Typography>
          <BlurText
            text="Where EWAS is standing guard"
            delay={30}
            style={{
              fontFamily: tokens.display,
              fontWeight: 500,
              fontSize: "clamp(1.8rem, 4vw, 2.6rem)",
              lineHeight: 1.2,
              color: tokens.paper,
              justifyContent: "center",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gridAutoRows: "1fr",
            gap: 4,
          }}
        >
          <Panel
            color={tokens.ember}
            tag="System 01"
            title="Forest Fire Early Warning"
            link="https://forestwatch.ewas.io"
          >
            Autonomous, solar-powered sensors keep continuous watch over forests
            and mountainsides, flagging fire and smoke early enough for a
            response — not just a record.
          </Panel>
          <Panel
            color={tokens.frost}
            tag="System 02"
            title="Human–Wildlife Conflict Early Warning"
            link="https://cameratrap.ewas.io"
          >
            In the mountains and forests where people and wildlife share the
            same ground, EWAS gives communities advance notice — so coexistence
            doesn&apos;t have to come at anyone&apos;s expense.
          </Panel>
        </Box>
      </Box>
    </Box>
  );
}
